import { render, staticRenderFns } from "./Asociate.vue?vue&type=template&id=597b8454&"
import script from "./Asociate.vue?vue&type=script&lang=ts&"
export * from "./Asociate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports